import { createEffect } from 'effector';
import { api } from 'src/shared/api/api';

export const PostcardActionsEvents = {
  SAVE: 'save',
  SHARE: 'share'
} as const;

export type PostcardActionsEventT = typeof PostcardActionsEvents[keyof typeof PostcardActionsEvents];

export const sendPostcardActionsEventFx = createEffect<PostcardActionsEventT, void, Error>(api.sendPostCardActionEvent);
